import React, { Component } from "react"
import { withStyles } from '@material-ui/core/styles';
import { TextField, Select, MenuItem, InputBase, InputAdornment, IconButton, FormControl, FormHelperText } from "@material-ui/core"
import Save from "../../../../Assets/img/svg/save.svg"
import Cancel from "../../../../Assets/img/svg/cancel.svg"
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../Assets/jss/customStyle";
import AttachFileIcon from '@material-ui/icons/AttachFile';
import Delete from "../../../../Assets/img/svg/delete.svg"
import del from "../../../../Assets/img/svg/Del.svg"
import $ from "jquery"
import moment from "moment"
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import axios from "axios";
import API from "../../../../helpers/endpointService"

const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

class DeleteShip extends Component {
    constructor(props) {
        super(props)
        this.inputFile = React.createRef();
        this.state = {
            isMobile: false,
            menu: true,
            isError1: false,
            ShipId: 0,
            ShipName: "",
            TypeShipName: "",
        }
    };
    componentDidMount() {
        const { dispatch } = this.props;
        this.state.UserRole = localStorage.getItem("UserRoles")
        this.state.ShipId = localStorage.getItem("DashId")
        this.state.ShipName = localStorage.getItem("ShipName")
        this.setState({})
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
        
    }
    componentWillUnmount() {
        clearInterval(this.interval);
        $("#Delete1 .MuiListItemText-primary").removeClass("spanTopBar")
        $("#DeleteShip1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#DeleteShip").addClass("d-none");
        $("#DeleteShip").removeClass("d-block");
        $("#DP .MuiListItemText-primary").removeClass("fw-bolder")
        $("#DPL").removeClass("active-color")
    }
    sidebar = () => {
        if (window.location.pathname == "/deleteship/deleteship") {
            this.props.navigate("/sidebareditship");
        }
        else {
            this.props.navigate("/sidebaraddship");
        }
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }

    };

    resize1 = () => {
        $("#Delete1 .MuiListItemText-primary").addClass("spanTopBar")
        $("#DeleteShip1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#DeleteShip").removeClass("d-none");
        $("#DeleteShip").addClass("d-block");
        $("#DP .MuiListItemText-primary").addClass("fw-bolder");
        $("#DPL").addClass("active-color")
    }

    getShipTypeName = (e) => {
        this.state.TypeShipName = e.target.value;
        this.setState({})
    };

    AddCancel = () => {
        this.props.navigate(`/shiplist`)
    };

    DeleteItem = () => {
        this.deleteship(this.state.ShipId,this.state.UserRole)
        window.$("#exampleModal123").modal("hide");
        this.state.TypeShipName = "";
        this.setState({})
    }

    deleteship = (data,name) => {
        let apiUrl = API.DELETE_SHIP + "id?id=" + data + '&modify=' + name;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "delete",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate(`/shiplist`)
                } else {

                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {

                   
                }
            });
    };

    render() {
        const { TypeShipName, ShipName } = this.state;
        let { classes, shipStatus, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4 mob-topfixed ">
                                <div className="col-7  mt-auto">
                                    <List className="pt-4 mt-4 " style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"Delete" + "1"} className='textNaviIcon' primary="Delete Ship" style={{ color: 'red' }} />
                                            <NavigateNextIcon id="Delete1" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-5 pt-2 mt-5 ">
                                    <h4 className="pt-2">Delete Ship</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide mt-138" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -75 }}>
                    {
                        this.state.isMobile ?
                            <table className="dataTable border-top" width="100%">
                                <tbody>
                                    <tr>
                                        <td className="border-right text-center" width="20%"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel}></i></td>
                                        <td className="text-left" width="80%">
                                            <button className={`${classes.button}`} data-target="#exampleModal123" data-toggle="modal" disabled={this.state.TypeShipName === this.state.ShipName ? false : true}  ><img src={Delete} style={{ marginTop: '-4px', opacity: this.state.TypeShipName === this.state.ShipName ? '' : '0.5' }}></img>&nbsp;Delete</button>
                                        </td>

                                    </tr>
                                </tbody>
                            </table>
                            :
                            <>
                                <table className="dataTable" width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="5%" className="border-right text-center">
                                                <i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel}></i></td>
                                            <td className="" width="" style={{ display: 'flex' }}>
                                                <button className={`${classes.button}`} data-target="#exampleModal123" data-toggle="modal" disabled={this.state.TypeShipName === this.state.ShipName ? false : true} ><img src={Delete} style={{ marginTop: '-4px', opacity: this.state.TypeShipName === this.state.ShipName ? '' : '0.5' }} ></img>&nbsp;Delete</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </>
                    }
                    <div style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        {this.state.isMobile ? "" : <h6 className="col-12 mx-2 mt-3 ml-1">Delete Ship</h6>}
                        <div className={this.state.isMobile ? "row mx-1" : "row mx-1 px-3 mt-4"}>
                            <div className={`row mt-2 mx-0 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                <div className={`col-12 col-sm-12  col-lg-12 col-xl-12 mt-2 col-md-12 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : ""}`}>
                                    <label className="pt-2" style={{ fontSize: '14px' }}>Are you sure you want to delete the "<span className="fw-bold">{this.state.ShipName}</span>" Ship? All users in this ship will immediately lose access.</label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-12 col-xl-12 col-md-12 ${this.state.isMobile ? "border-left border-right col-md-12 pt-2" : "col-12 col-sm-12  col-lg-12 col-xl-12 mt-2 col-md-12"}`}>
                                    <span lassName="pt-2 pb-4">To confirm this action, please type <span className="fw-bold">{this.state.ShipName}</span>.</span>
                                </div>
                                <div className={`col-12 col-sm-12 pb-4  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2" : "col-md-4 pt-2"}`}>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.TypeShipName}
                                        onChange={(e) => { this.getShipTypeName(e) }}
                                        placeholder="Type Ship Name"
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                   
                </div>
                <div class="modal fade p-5 mt-5" id="exampleModal123" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#499AC8", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} id="closemodal1" data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
    };
}

DeleteShip.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(DeleteShip))
);
